export default __webpack_public_path__ + "static/media/0014.262d9998.jpg";